<template lang="pug">
    div
        q_text(
        question="First Name"
        slug="q_guardian_first_name"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Last Name"
        slug="q_guardian_last_name"
        :multi_field_num="multi_field_num"
        )
        q_static_ddl(
        question="Suffix"
        slug="q_guardian_suffix"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="Email"
        slug="q_guardian_email"
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="Country",
        slug='q_guardian_home_country'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Street'
        slug='q_guardian_home_street'
        placeholder='Street'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='City'
        slug='q_guardian_home_city'
        placeholder='City'
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="State",
        slug='q_guardian_home_state'
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="Province",
        slug='q_guardian_home_province'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Zip'
        slug='q_guardian_home_zip'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Postal'
        slug='q_guardian_home_postal'
        :multi_field_num="multi_field_num"
        )
        q_text(
        question='Preferred Phone'
        slug='q_guardian_preferred_phone'
        :multi_field_num="multi_field_num"
        )
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_text from "../../baseQuestion/text";
import q_static_ddl from "../../baseQuestion/staticDDL";
import q_searchable_ddl from "../../baseQuestion/searchableDDL";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_text,
		q_static_ddl,
		q_searchable_ddl
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		}
	}
};
</script>
